import { toGlobalId } from 'graphql-relay';
import getFieldsForCards from './getFieldsForCards';

export default function getFieldsForSections(offer, contentDetails, states, stateInteractions) {
  const sections = offer.children.map((section) => {
    const cards = getFieldsForCards(offer, contentDetails, section, states, stateInteractions);
    const sectionPerformance = states.find(state => state.contentId === section._id);
    const fields = {
      id: toGlobalId('Section', section._id),
      pid: section._id,
      name: section.content.name,
      position: section.content.globalPosition,
      cards,
      sectionPerformance: {
        id: toGlobalId(
          'SectionPerformance',
          `${section.userId}_${section.rootContentId_contentId}`
        ),
        timeSpent: sectionPerformance.timeSpent,
        completionDate: sectionPerformance.completedOn,
        progressMeasure: sectionPerformance.progressMeasure,
        scaledProgressMeasure: sectionPerformance.scaledProgressMeasure,
        successStatus: sectionPerformance.successStatus,
        completionStatus: sectionPerformance.completionStatus
      }
    };
    return fields;
  });
  const fields = {
    sections
  };
  return fields;
}
